module.exports = __webpack_public_path__ + "img/pimg14.34edb466.png";